import { createFileRoute } from '@tanstack/react-router';
import { Header } from '@/components/Header';
import { GroupDetail } from '@/pages/GroupDetail';

export const Route = createFileRoute(
  '/_authenticated/_admin/admin/manage-groups/$groupId'
)({
  component: GroupDetailPage,
});

function GroupDetailPage() {
  const { groupId } = Route.useParams();

  return (
    <>
      <Header
        enableBack
        fallbackTo="/admin/manage-groups"
        additionalClasses="bg-slate-700"
      />
      <GroupDetail groupId={groupId} />
    </>
  );
}
